import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import FileUpload from './FileUpload'; 
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from './CreatePage.module.css';

const ChatbotPage = () => {
    const [showFileUpload, setShowFileUpload] = useState(false);
    const navigate = useNavigate();

    const handleCreateClick = () => {
        setShowFileUpload(true);
    };

    const handleBackToHome = () => {
        navigate('/', { replace: true });
    };

    return (
        <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.4 }}
        >
            <Box className={styles.container}>
                <Box className={styles.innerContainer}>
                    {/* Left Panel */}
                    <Box className={styles.leftPanel}>
                        <Box className={styles.innerDashedBorder}>
                            <Box>
                                <Typography variant="h6" className={styles.title}>
                                    Text Agents
                                </Typography>
                                <hr className={styles.titleLine} />
                                <Box className={styles.emptyState}>
                                    <Typography className={styles.emptyText}>
                                        No text agents available at this moment.
                                    </Typography>
                                </Box>
                            </Box>

                            <Box className={styles.footerButtons}>
                                <Button
                                    variant="outlined"
                                    className={styles.blackBorderButton}
                                    onClick={handleCreateClick}
                                >
                                    Create chatbot
                                </Button>
                                <Button
                                    variant="outlined"
                                    className={styles.blackBorderButton}
                                    onClick={handleBackToHome}
                                >
                                    Back to Home
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                    {/* Right Panel */}
                    <Box className={styles.rightPanel}>
                        {!showFileUpload ? (
                            <Box className={styles.createChatbot}>
                                <Typography className={styles.createTitle}>
                                    Create a chatbot to start
                                </Typography>
                            </Box>
                        ) : (
                            <motion.div
                                initial={{ x: 20, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                transition={{ duration: 0.5 }}
                                style={{ width: '100%' }}
                            >
                                <Box className={styles.innerRightContainer}>
                                    <FileUpload onCancel={() => setShowFileUpload(false)} />
                                </Box>
                            </motion.div>
                        )}
                    </Box>
                </Box>
            </Box>
        </motion.div>
    );
};

export default ChatbotPage;